<template>
  <q-dialog v-model="dialogChannel" persistent @show="setValue()">
    <q-card>
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title>
          {{ channelSelect ? $t('edit') : $t('registration_of') }} {{ $t('channel') }}
          {{ channelId ? `(${channelId})` : '' }}
        </q-toolbar-title>
        <q-btn flat icon="mdi-close" @click="onClose()" round dense />
      </q-toolbar>
      <q-form @submit="onEdit">
        <q-card-section class="row q-col-gutter-md">
          <div class="col-12">
            <q-input
              outlined
              :label="isPicpayAffiliate ? 'Nome da rádio' : $t('name') + ' ' + $t('of_2') + ' Site'"
              type="text"
              v-model="params.name"
              lazy-rules
              :rules="[isRequired]"
            />
          </div>
          <div class="col-12">
            <q-select
              v-model="params.channelType"
              use-input
              input-debounce="200"
              @filter="filterTypeChannels"
              :options="typeChannelsFiltered"
              :label="$t('type') +' '+ $t('of_2') + ' ' + $t('channel')"
              outlined
              option-label="site_type"
              option-value="id"
              clear-icon="mdi-close"
              clearable
              lazy-rules
              :rules="[isRequired]"
            />
          </div>
          <div class="col-12">
            <q-select
              v-model="params.category"
              use-input
              input-debounce="200"
              @filter="filterCategories"
              :options="categoriesFiltered"
              :label="$t('category')"
              outlined
              option-label="name"
              option-value="id"
              clear-icon="mdi-close"
              clearable
              lazy-rules
              :rules="[isRequired]"
            />
          </div>
          <div class="col-12">
            <q-input
              outlined
              :label="isPicpayAffiliate ? 'Site da rádio' : 'URL'"
              type="text"
              v-model="params.url"
              lazy-rules
              :rules="[validURL]"
              error-message="Verifique a URL"
            />
          </div>
          <div class="col-12">
            <q-input
              outlined
              v-model="params.description"
              type="textarea"
              :label="$t('description')"
              counter
              maxlength="500"
              :placeholder="$t('u_have_500_characters')"
              lazy-rules
              :rules="[isRequired]"
            />
          </div>
          <template v-if="isPicpayAffiliate">
            <div class="col-12 col-md-6">
              <q-input
                outlined
                label="Frequência (MHz)"
                type="number"
                step="0.1"
                min="87.5"
                max="108"
                v-model.number="params.dial"
                lazy-rules
                :rules="[validDial]"
                hint="Ex.: 95.1, 102.1 — faixa FM (87,5 a 108 MHz)"
              />
            </div>
            <div class="col-12 col-md-6">
              <q-select
                v-model="params.region"
                :options="regions"
                label="Região"
                outlined
                clear-icon="mdi-close"
                clearable
                lazy-rules
                :rules="[isRequired]"
              />
            </div>
            <div class="col-12 col-md-12">
              <q-select
                v-model="params.frequencyType"
                :options="frequencyTypes"
                label="Tipo de frequência"
                outlined
                clear-icon="mdi-close"
                clearable
                lazy-rules
                :rules="[isRequired]"
              />
            </div>
          </template>

          <div class="col-12 text-right">
            <q-btn color="positive" :label="$t('save')" no-caps unelevated type="submit" class="q-px-md" />
          </div>
        </q-card-section>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import ChannelMixin from '../../mixins/ChannelMixin';
import AffiliateService from '../../services/AffiliateService';
import AdvertiserService from '../../services/AdvertiserService';

export default {
  name: 'FormMyChannels',
  mixins: [ChannelMixin, AffiliateService, AdvertiserService],
  data() {
    return {
      categories: [],
      categoriesFiltered: [],
      typeChannels: [],
      typeChannelsFiltered: [],
      params: {
        id: null,
        category: null,
        channelType: null,
        description: null,
        name: null,
        url: null,
        dial: null,
        region: null,
        frequencyType: null
      },
      channelId: null,
      regions: ['Norte', 'Sul', 'Centro-Oeste', 'Sudeste', 'Nordeste'],
      frequencyTypes: ['AM', 'FM'],
      refererAdvertiserForPicpay: null,
      refererAdvertiserLoadSeq: 0
    };
  },
  computed: {
    isPicpayAffiliate() {

      const isAdvertiserReferer =
        this.user.affiliate.referer_id != null &&
        this.user.affiliate.referer_id !== '' &&
        this.user.affiliate.referer_type === 'advertiser';

      if (isAdvertiserReferer) {
        const key = this.refererAdvertiserForPicpay && this.refererAdvertiserForPicpay.referer_key;
        return String(key || '').toLowerCase() === 'picpay';
      }

      const refererKey =
        (this.user && this.user.referer_key) ||
        (this.user.affiliate && this.user.affiliate.referer_key) ||
        '';
      return String(refererKey).toLowerCase() === 'picpay';
    }
  },
  methods: {
    async syncRefererAdvertiserForPicpay() {
      const needsAdvertiser =
        this.user.affiliate.referer_id != null &&
        this.user.affiliate.referer_id !== '' &&
        this.user.affiliate.referer_type === 'advertiser';

      if (!needsAdvertiser) {
        this.refererAdvertiserForPicpay = null;
        return;
      }

      const seq = ++this.refererAdvertiserLoadSeq;
      try {
        this.onLoading(true);
        const { data, status } = await this.getAdvertiserById(this.user.affiliate.referer_id);
        if (seq !== this.refererAdvertiserLoadSeq) return;
        this.refererAdvertiserForPicpay = status === 200 ? data : null;
      } catch (e) {
        if (seq !== this.refererAdvertiserLoadSeq) return;
        this.refererAdvertiserForPicpay = null;
      } finally {
        this.onLoading(false);
      }
    },

    filterCategories(val, update) {
      update(() => {
        const needle = val.toLocaleLowerCase();
        if (!needle) this.categoriesFiltered = this.categories;
        this.categoriesFiltered = this.categories.filter((v) => v.name.toLocaleLowerCase().indexOf(needle) > -1);
      });
    },

    filterTypeChannels(val, update) {
      update(() => {
        const needle = val.toLocaleLowerCase();
        if (!needle) this.typeChannelsFiltered = this.typeChannels;
        this.typeChannelsFiltered = this.typeChannels.filter(
          (v) => v.site_type.toLocaleLowerCase().indexOf(needle) > -1
        );
      });
    },

    /** Normaliza o dial (MHz) vindo da API ou do input — um decimal, faixa FM. */
    parseDial(dial) {
      if (dial == null || dial === '') return null;
      const n = typeof dial === 'number' ? dial : parseFloat(String(dial).replace(',', '.'));
      if (!Number.isFinite(n)) return null;
      return Math.round(n * 10) / 10;
    },

    validDial(v) {
      if (v === null || v === undefined || v === '') {
        return 'Informe a frequência em MHz (ex.: 95.1)';
      }
      const n = this.parseDial(v);
      if (n === null) return 'Use um número válido (ex.: 95.1)';
      if (n < 87.5 || n > 108) return 'Informe uma frequência entre 87,5 e 108 MHz';
      return true;
    },

    onClose() {
      this.ActionSetDialogChannel(false);
      this.ActionSetChannelSelect({});
    },

    async getTypeChannels() {
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          '/v2/redirect?app=AFFILIATE&path=/api/get/affiliate/list_site_type'
        );
        if (status === 200) this.typeChannels = data;
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async getCategories() {
      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          'v2/redirect?app=AFFILIATE&path=/api/get/affiliate/list_site_categories'
        );
        if (status === 200) this.categories = data;
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    setValue() {
      this.syncRefererAdvertiserForPicpay();
      if (this.channelSelect) {
        const {
          name,
          url,
          description,
          site_type,
          category,
          dial,
          region,
          frequency_type: frequency_type_snake,
          frequencyType: frequency_camel
        } = this.channelSelect;
        const frequency_type = frequency_type_snake != null ? frequency_type_snake : frequency_camel;
        this.params = {
          name,
          url,
          description,
          channelType: this.typeChannels.find((item) => item.site_type === site_type),
          category: this.categories.find((item) => item.name === category),
          dial: this.parseDial(dial),
          region: region != null && region !== '' ? region : null,
          frequencyType: frequency_type != null && frequency_type !== '' ? frequency_type : null
        };
      } else {
        this.params = {
          name: null,
          url: null,
          description: null,
          channelType: null,
          category: null,
          dial: null,
          region: null,
          frequencyType: null
        };
      }
    },

    urlHttp(urlInput) {
      if (urlInput) {
        let https = urlInput.slice(0, 8).toLowerCase();
        let http = urlInput.slice(0, 7).toLowerCase();
        if (https === 'https://') return urlInput;
        else if (http === 'http://') return urlInput;
        else return 'http://' + urlInput;
      } else return '';
    },

    onEdit() {
      if (this.channelId !== null) {
        let paramsEdit = {
          name: this.params.name,
          description: this.params.description,
          url: this.params.url,
          site_type_id: this.params.channelType.id,
          category: this.params.category.id
        };

        if (this.isPicpayAffiliate) {
          paramsEdit = {
            ...paramsEdit,
            dial: this.parseDial(this.params.dial),
            region: this.params.region,
            frequency_type: this.params.frequencyType
          };
        }

        return this.editChannel(paramsEdit);
      }

      let paramsEdit = {
        name: this.params.name,
        description: this.params.description,
        url: this.urlHttp(this.params.url),
        site_type_id: this.params.channelType.id,
        category: this.params.category.id,
        affiliate_id: this.user.affiliate.id
      };

      if (this.isPicpayAffiliate) {
        paramsEdit = {
          ...paramsEdit,
          dial: this.parseDial(this.params.dial),
          region: this.params.region,
          frequency_type: this.params.frequencyType
        };
      }

      return this.createChannel(paramsEdit);
    },

    async editChannel(paramsEdit) {
      this.onLoading(true);
      try {
        const { data, status } = await this.editAffiliateChannel(this.channelSelect.id, paramsEdit);
        if (status === 200 || status === 201) {
          this.getMyChannels();
          this.successNotify(data.message);
          this.onClose();
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async createChannel(paramsEdit) {
      this.onLoading(true);
      try {
        const { status } = await this.createAffiliateChannel(paramsEdit);
        if (status === 200 || status === 201) {
          this.getMyChannels();
          this.successNotify('Canal criado com sucesso');
          this.onClose();
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  },
  created() {
    this.getTypeChannels();
    this.getCategories();
    this.syncRefererAdvertiserForPicpay();
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.syncRefererAdvertiserForPicpay();
      }
    },
    channelSelect() {
      if (this.channelSelect !== undefined && this.channelSelect !== null) {
        this.channelId = this.channelSelect.id;
      } else {
        this.channelId = null;
      }
    }
  }
};
</script>
